export enum LoyaltyScoreBarColors {
  DEVOTED = "#6A2AFF",
  LOYAL = "#66BF7E",
  FREQUENT = "#66BF7E",
  CASUAL = "#FA966F",
  STRANGER = "#D7D7D7"
}

export enum LoyaltyScoreBarBackgroundColors {
  PURPLE = "#A686F0",
  LOYAL = "#D1F4DA",
  FREQUENT = "#D1F4DA",
  CASUAL = "#FFDDD0",
  STRANGER = "#D7D7D7"
}
